import { DealQuestion, DealValueOption, ModelValue } from ".";
import { formatDealValueString } from "../functions";

export class DealValue {

  /**
 * Gets or sets the unique identifier for the deal value.
 */
  id?: string | null;

  /**
   * Optional, the user who created the deal value.
   */
  createdFor?: string | null;

  /**
   * Gets or sets the unique identifier for the related question.
   */
  modelValueId?: string | null;

  /**
   * Gets or sets the time segment.
   */
  timeSegment?: number | null;

  /**
   * Gets or sets the row number.
   */
  rowNo?: number | null;

  /**
   * The client variable name associated with the question.
   */
  varName?: string | null;

  /**
   * Gets or sets the question code.
   */
  code?: string | null;

  /**
   * Gets or sets the client control code.
   */
  controlCode?: string | null;

  /**
   * Gets or sets the data type, n, s or dt
   */
  dataTypeCode?: string | null;

  /**
   * Gets or sets the type of the deal. 
   */
  dealType?: string | null;

  /**
   * Gets or sets the unique identifier for the deal.
   */
  dealId?: string | null;

  /**
   * Gets or sets the unique identifier for the deal item.
   */
  dealItemId?: string | null;

  /**
   * Gets or sets the guid value for the answer.
   */
  gVal?: string | null;

  /**
   * Gets or sets the string value of the answer.
   */
  sVal?: string | null;

  /**
   * Gets or sets the numeric value of the answer.
   */
  nVal?: number | null;

  /**
   * Gets or sets the numeric value of the answer incl. custom adjustment.
   */
  nValCa?: number | null;

  /**
   * Gets or sets the numeric value of the adjustment only (i.e. nValCa - nVal).
   */
  nValCaAdj?: number | null;

  /**
   * Gets or sets the date/time value of the answer.
   */
  dtVal?: Date | null;

  /**
   * Gets or sets any comments associated with the answer.
   */
  comments?: string | null;

  /**
   * Gets or sets the list of options for the question answer.
   */
  options?: DealValueOption[] | null;

  constructor(init?: Partial<DealValue>) {
    Object.assign(this, init);
  }

}


/**
  * Create a comparison key for the deal value
  * Deliberately using export function
  */
export function DealValueComparisonKey(item: DealValue): string {

  return (item.modelValueId ?? 'null') + '_' + (item.code ?? 'null') + '_' + (item.dealItemId ?? 'null') + '_' + (item.timeSegment ?? '1') + '_' + (item.rowNo ?? '1') + '_' + (item.createdFor ?? '');
}

/**
 * Compare two values to see if their data is equivalent
 * Does not check the deal value id 
 */
export function DealValueAreEqual(a: DealValue, b: DealValue): boolean {

  if (a === b)
    return true;

  if (a == null || b == null)
    return false;

  // need to compare the options values
  if (a.options && b.options) {
    if (a.options.length !== b.options.length)
      return false;
    for (let i = 0; i < a.options.length; i++) {
      if (a.options[i].valueOptionId !== b.options[i].valueOptionId)
        return false;
    }
  }
  else if ( (a.options && a.options.length > 0)
    || (b.options && b.options.length > 0)
  )
    return false;

  // check the other properties
  return (a.modelValueId ?? null) === (b.modelValueId ?? null) &&
    (a.code ?? null) === (b.code ?? null) &&
    (a.timeSegment ?? null) === (b.timeSegment ?? null) &&
    (a.rowNo ?? null) === (b.rowNo ?? null) &&
    (a.createdFor ?? null) === (b.createdFor ?? null) &&
    (a.sVal ?? null) === (b.sVal ?? null) &&
    (a.nVal ?? null) === (b.nVal ?? null) &&
    (a.dtVal ?? null) === (b.dtVal ?? null) &&
    (a.gVal ?? null) === (b.gVal ?? null);

}
